export const SYSTEM_NOTICE_CATEGORY_OPTIONS = [
  { value: 'GENERAL', label: '일반' },
  { value: 'WORK', label: '작업' },
  { value: 'UPDATE', label: '업데이트' },
  { value: 'EVENT', label: '이벤트' },
  { value: 'ETC', label: '기타' },
]

export function getSystemNoticeCategoryLabel(value) {
  return SYSTEM_NOTICE_CATEGORY_OPTIONS.find(option => option.value === value)?.label || '일반'
}

export function getSystemNoticeCategoryBadgeClass(value) {
  switch (value) {
    case 'WORK':
      return 'bg-amber-100 text-amber-800'
    case 'UPDATE':
      return 'bg-sky-100 text-sky-800'
    case 'EVENT':
      return 'bg-emerald-100 text-emerald-800'
    case 'ETC':
      return 'bg-slate-200 text-slate-700'
    case 'GENERAL':
    default:
      return 'bg-stone-100 text-stone-700'
  }
}
